export function getTranslatedName(roles, locale, displayName) {
  if (!roles) {
    return displayName;
  }
  return roles.reduce((acc, x) => x.get('en-US') === displayName && x.has(locale) ? x.get(locale) : acc, displayName);
}
